import { APICallV3Post } from 'reactApp/api/APICall';

import type {
    UpgradeSubscriptionPlanArgs,
    UpgradeSubscriptionPlanResponse,
    UpgradeSubscriptionSetArgs,
    UpgradeSubscriptionSetResponse,
} from './UpgradeSubscriptionAPICall.types';

export class UpgradeSubscriptionPlanAPICall extends APICallV3Post<UpgradeSubscriptionPlanResponse, UpgradeSubscriptionPlanArgs> {
    _method = 'billing/change/plan';
}

export class UpgradeSubscriptionSetAPICall extends APICallV3Post<UpgradeSubscriptionSetResponse, UpgradeSubscriptionSetArgs> {
    _method = 'billing/change/set';
}
